<script>
   /*********************************************************
   * AcceptancePlotLegend                                   *
   * --------------------                                   *
   * shows color map legend on Acceptance plot              *
   **********************************************************/

   import { ColormapLegend } from 'svelte-plots-basic/2d';
   import { CAT_COLORS, getClassColors } from '../../../shared/plots/Defaults.js';

   export let resobj;               // SIMCA result object
   export let ncomp = 1;            // number of components selected by user
   export let isAlt = false;        // predictions for target class or alternative?
   export let colorBy = 'roles';    // how to color group data points ('roles' or 'classes')

   /**
    * Returns JSON with every reference class and number of samples in that class
    * @param resobj - JSON with SIMCA result object
    */
   function getClassCategories(resobj) {
      if (!resobj || !resobj.classNames || !resobj.classes || resobj.classNames.length < 1) return null;
      return resobj.classes.reduce((acc, curr) => {
         acc[curr] = (acc[curr] || 0) + 1;
         return acc;
      }, {});
   }

   // categories and colors for classes
   $: classCategories = colorBy === 'classes' ? getClassCategories(resobj) : null;
   $: classColmap = classCategories ? getClassColors(resobj.classNames) : null;
   $: catColors = colorBy === 'roles' ? CAT_COLORS : classColmap;

   // categories, colors and labels for the legend
   $: categories = resobj ?
      (
         isAlt ?
         (colorBy === 'roles' ? resobj.v[ncomp - 1].anum : classCategories) :
         resobj.v[ncomp - 1].cnum
      )
      : null;
   $: labels = categories ? Object.keys(categories).map(v => v + ': ' + categories[v]) : null;
   $: colmap = categories ? Object.keys(categories).map(v => catColors[v]) : null;
   $: breaks = labels ? labels.map((v, i) => i) : null;
</script>

<ColormapLegend {colmap} {breaks} labels={labels}/>



